import { z } from 'zod';

/**
 * The AG-UI message shape the agentic platform replays a session's history in.
 *
 * @see backend/agentic-platform/schema/src/agUi/message.ts
 */
export const AgenticPlatformToolCallSchema = z.object({
  function: z.object({ arguments: z.string(), name: z.string() }),
  id: z.string(),
  type: z.literal('function'),
});
export type AgenticPlatformToolCall = z.infer<typeof AgenticPlatformToolCallSchema>;

export const AgenticPlatformMessageRoleSchema = z.enum([
  'assistant',
  'developer',
  'system',
  'tool',
  'user',
]);
export type AgenticPlatformMessageRole = z.infer<typeof AgenticPlatformMessageRoleSchema>;

export const AgenticPlatformMessageSchema = z.object({
  content: z.string().optional(),
  /** Present on a tool message only when the call failed. */
  error: z.string().optional(),
  id: z.string(),
  role: AgenticPlatformMessageRoleSchema,
  toolCallId: z.string().optional(),
  toolCalls: z.array(AgenticPlatformToolCallSchema).optional(),
});
export type AgenticPlatformMessage = z.infer<typeof AgenticPlatformMessageSchema>;

export const AgenticPlatformSessionSchema = z.object({
  created: z.string(),
  id: z.string(),
  subtitle: z.string().nullable(),
  title: z.string().nullable(),
  updated: z.string(),
  userId: z.string(),
});
export type AgenticPlatformSession = z.infer<typeof AgenticPlatformSessionSchema>;

export const CreateAgenticPlatformSessionValuesSchema = z.object({
  subtitle: z.string().optional(),
  title: z.string().optional(),
});
export type CreateAgenticPlatformSessionValues = z.infer<
  typeof CreateAgenticPlatformSessionValuesSchema
>;

/** A `null` label clears it; a missing label leaves it as it is. */
export const UpdateAgenticPlatformSessionValuesSchema = z.object({
  subtitle: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
});
export type UpdateAgenticPlatformSessionValues = z.infer<
  typeof UpdateAgenticPlatformSessionValuesSchema
>;
